<template>
  <DSelect
    :items="itemsFiltered"
    :itemsSelected="itemsSelectedFormatted"
    placeholder="Tilføj underviser"
    :isDeleteAllAnOption="false"
    :show="true"
    @update="update"
    @close="$emit('close')">
    <h4 slot="noMatch">Ingen personer matcher</h4>
  </DSelect>
</template>
<script>
import DSelect from '../../DSelect/DSelectCals'

export default {
  components: {DSelect},
  props: {
    items: {
      default: () => [],
      type: Array
    },
    itemsSelected: {
      default: () => [],
      type: Array
    },
    usersSSNHash: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    itemsFiltered () {
      return this.items.filter(user => this.usersSSNHash[user.ssn])
    },
    itemsSelectedFormatted () {
      const usersNotOnSchool = this.itemsSelected.filter(user => !this.usersSSNHash[user.cpr]).map(user => {
        return {
          id: user.user_id,
          name: user.user_name
        }
      })
      const users = this.itemsSelected.filter(user => this.usersSSNHash[user.cpr]).map(user => this.usersSSNHash[user.cpr])
      return usersNotOnSchool.concat(users)
    }
  },
  methods: {
    update (val) {
      this.$emit('update', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// KompetenceIndberetningKlasserDSelect.vue?831a6f02